export const downloadBlob = (data, fileName) => {
  const url = window.URL.createObjectURL(new Blob([data]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', extractDisplayName(fileName))
  document.body.appendChild(link)
  link.click()
}

// Extensions for which DocViewerPreview will open (shows content or a friendly fallback).
// CAD files are excluded — they go to CadPreview instead.
export const DOC_VIEWER_EXTENSIONS = [
  // Office Online
  'xlsx', 'xlsm', 'xls', 'docx', 'doc', 'pptx', 'ppt',
  // Native PDF
  'pdf',
  // Images
  'png', 'jpg', 'jpeg', 'gif', 'bmp', 'tif', 'tiff', 'heic',
  // Text
  'csv', 'txt',
  // HTML
  'html', 'htm',
  // Unsupported but show download message instead of nothing
  'bin', 'msg', 'zip', 'rar', 'eml', 'mp4', 'exe', 'qt',
]

export const CAD_PREVIEW_EXTENSIONS = ['dxf', 'dwg', 'dwt', 'dws']

// Max file size for in-browser preview — default 50 MB, configurable via env var
const envMaxMb = Number(process.env.REACT_APP_PREVIEW_MAX_FILE_SIZE_MB)
export const MAX_PREVIEW_FILE_SIZE_BYTES = (Number.isFinite(envMaxMb) && envMaxMb > 0)
  ? envMaxMb * 1024 * 1024
  : 50 * 1024 * 1024

export const getFileExtension = (filePath) => {
  if (!filePath || typeof filePath !== 'string') return ''
  return filePath.split('.').pop()?.toLowerCase() || ''
}

export const isDocViewerFile = (filePath) =>
  DOC_VIEWER_EXTENSIONS.includes(getFileExtension(filePath))

export const isCadPreviewFile = (filePath) =>
  CAD_PREVIEW_EXTENSIONS.includes(getFileExtension(filePath))

export const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      const base64String = reader.result.split(',')[1]
      resolve(base64String)
    }
    reader.onerror = () => {
      reject(new Error('Failed to convert blob to base64'))
    }
    reader.readAsDataURL(blob)
  })
}

export const extractDisplayName = (filePath) => {
  if (!filePath) return ''
  const fileName = filePath.split('/').pop()

  const lastDashIndex = fileName.lastIndexOf('-')
  const lastDotIndex = fileName.lastIndexOf('.')

  if (lastDashIndex !== -1 && lastDotIndex !== -1) {
    return fileName.substring(0, lastDashIndex) + fileName.substring(lastDotIndex)
  }

  return fileName
}
